// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1___6a9343bb6a1b2eedd33","cls2":"AuthorHeader-cls2___cea6a0267f637622d3c AuthorHeader-cls1___6a9343bb6a1b2eedd33"};